module.exports = "/img/total-car-cost-calculator-banner.5790c797.png";